import { get } from "lodash";
import { COMPANY, SHIP_TO_TYPE } from "APP_ROOT/constants";

export function initialValues(lineItem, currentUser, mro) {
  const values = {
    buyer_id: get(mro, "buyer.id"),
    request_vendor_approval: false,
    request_shop_approval: false,
    same_as_billing: true,
    evaluation_period: 30,
    reserve_for_seller_id: currentUser.id,
    read_only_buyer: get(mro, "buyer.full_name"),
    insurance_type: "None",
    cancelled: false,
    part: {
      pass_fail: get(lineItem, "part.pass_fail")
    },
    purchase_for_sale: false,
    purchase_for_stock: false,
    purchase_for_repair: false,
    purchase_for_repair_assist: false,
    preferred_repair_station_id:
      get(mro, SHIP_TO_TYPE) === COMPANY && get(mro, "ship_to_company_id"),
    buyer_credit_pct: 75,
    tagged_by: undefined,
    tagged_by_id: undefined,
    tagged_by_hold: false
  };

  values.buyer_credit_pct = mro.buyer_credit_pct;
  values.co_buyer_id = mro.co_buyer_id;
  values.third_buyer_id = mro.third_buyer_id;
  if (lineItem) {
    lineItem.co_buyer = mro.co_buyer;
    lineItem.third_buyer = mro.third_buyer;
  }

  return values;
}



// WEBPACK FOOTER //
// ./app/modules/ManagedRepairOrders/helpers.js